import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const McoClaimList = () => {
  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.progId.precedence = 1;
    fieldToFieldDef.progId.hasName = false;

    fieldToFieldDef.payeeCustId.precedence = 2;
    fieldToFieldDef.payeeCustId.hasName = false;

    fieldToFieldDef.rbtPeriodId.precedence = 3;
    fieldToFieldDef.rbtPeriodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Amounts
    fieldToFieldDef.invAmt.precedence = 2001;
    fieldToFieldDef.dispAmt.precedence = 2002;
    fieldToFieldDef.dueAmt.precedence = 2003;
    fieldToFieldDef.paidAmt.precedence = 2004;
  };

  return <EntityList entity="MCO_CLAIM" augFieldDefs={augFieldDefs} />;
};
